import { useCallback, useEffect, useRef } from 'react';
import { isKeyboardFocus } from '../utils';

type FocusTarget = () => HTMLElement | null | undefined;

export const useRestoreFocusAfterFetch = (isFetched: boolean) => {
  const focusTargetRef = useRef<FocusTarget | null>(null);

  useEffect(() => {
    const focusTarget = focusTargetRef.current;

    if (!isFetched || !focusTarget) {
      return;
    }

    focusTargetRef.current = null;

    if (document.activeElement !== document.body) {
      return;
    }

    focusTarget()?.focus();
  }, [isFetched]);

  return useCallback((focusTarget: FocusTarget) => {
    focusTargetRef.current = isKeyboardFocus() ? focusTarget : null;
  }, []);
};
